import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import { reduxForm, FieldArray, Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
// import { Values } from "redux-form-website-template";
import { FormField, Responsive, Toolbar, GET_LIST } from "admin-on-rest";
import getDefaultValues from "../components/form/getDefaultValues";
import { RestClient } from "../restClient";
import {
  Table,
  TableBody,
  TableHeader,
  TableFooter,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { TextField, SelectField } from "redux-form-material-ui";
import MenuItem from "material-ui/MenuItem";
import { Card, CardHeader, CardText } from "material-ui/Card";
import FlatButton from "material-ui/FlatButton";
import ContentAdd from "material-ui/svg-icons/content/add-circle";
import ActionDelete from "material-ui/svg-icons/action/highlight-off";

import Avatar from "material-ui/Avatar";
import IconPeople from "material-ui/svg-icons/social/people";
import { DivErrorMessage } from "./styled";
import { RestApiShortUrl } from "../restClient";
import Snackbar from "material-ui/Snackbar";
import { red500 } from "material-ui/styles/colors";
class PageForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      // if(values.marketer_id ===  null){
      //   values.marketer_id = 0;
      // }
      if (!Array.isArray(values.collections)) {
        values.collections = [];
      }
      if (this.state.slug === values.slug) {
        this.props.save(values, redirect);
      } else {
        this.getSlug(values, redirect);
      }
      //this.props.save(values, redirect)
    });

  constructor(props) {
    super(props);
    this.state = {
      marketers: [],
      open: false,
      oldMarketers: props.record.marketers || [],
      slug: props.record.slug,
      message: "The Slug already have",
      expandedMarketer: false
    };
    this.getMarketers();
  }
  getMarketers = () => {
    RestClient(GET_LIST, "marketers", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "first_name", order: "ASC" },
      filter: {}
    })
      .then(items => {
        this.setState({ marketers: items.data });
      })
      .catch(e => {
        //console.error(e);
      });
  };
  getSlug = (values, redirect) => {
    RestApiShortUrl(values.slug)
      .then(response => {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (!data.exists) {
          this.props.save(values, redirect);
        } else {
          this.setState({
            open: true,
            message: "The Slug already have"
          });
        }
      })
      .catch(e => {
        this.setState({
          open: true,
          message: "Please try again"
        });
        //console.error(e);
      });
  };
  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };
  getItemSlug = slug => {
    RestApiShortUrl(slug)
      .then(response => {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (!data.exists) {
          this.setState({
            open: true,
            message: "You can use this Slug"
          });
        } else {
          this.setState({
            open: true,
            message: "The Slug already have"
          });
        }
      })
      .catch(e => {
        this.setState({
          open: true,
          message: "Please try again"
        });
        //console.error(e);
      });
  };

  handleExpandMarketerChange = expanded => {
    this.setState({ expandedMarketer: expanded });
  };

  renderMarketersList = ({ fields, meta: { error, submitFailed } }) => {
    return (
      <div>
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow style={{ textAlign: "center" }}>
              <TableHeaderColumn>Marketer</TableHeaderColumn>
              <TableHeaderColumn>Slug</TableHeaderColumn>
              <TableHeaderColumn />
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {fields.map(this.renderMarketersFields)}
          </TableBody>
          <TableFooter adjustForCheckbox={false}>
            <TableRow>
              <TableRowColumn style={{ textAlign: "center" }}>
                <FlatButton
                  primary
                  label="add Marketer"
                  onClick={() => fields.push({ marketer_id: 9, slug: "" })}
                  icon={<ContentAdd />}
                />
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
        {submitFailed && error && <DivErrorMessage> {error} </DivErrorMessage>}
      </div>
    );
  };

  checkSlug = index => {
    let { marketers } = this.props;
    if (marketers[index].slug) {
      if (
        this.state.oldMarketers[index] !== undefined &&
        this.state.oldMarketers[index].slug !== undefined
      ) {
        if (marketers[index].slug !== this.state.oldMarketers[index].slug) {
          this.getItemSlug(marketers[index].slug);
        }
      } else {
        this.getItemSlug(marketers[index].slug);
      }
    } else {
      this.setState({
        open: true,
        message: "Slug is empty"
      });
    }
  };
  renderMarketersFields = (items, index, fields) => {
    return (
      <TableRow key={index}>
        <TableRowColumn style={styles.rowMarketers}>
          <Field
            key={index}
            label=""
            name={`${items}.marketer_id`}
            component={SelectField}
            placeholder="marketer"
          >
            {this.state.marketers.map((item, indexx) => {
              return (
                <MenuItem
                  value={item.id}
                  key={indexx}
                  primaryText={`${item.first_name} ${item.last_name}`}
                />
              );
            })}
          </Field>
        </TableRowColumn>
        <TableRowColumn>
          <Field
            label=""
            name={`${items}.slug`}
            component={TextField}
            fullWidth
          />
        </TableRowColumn>
        <TableRowColumn style={styles.rowFooter}>
          <FlatButton
            primary
            label="Check Slug"
            onClick={() => this.checkSlug(index)}
          />
          <span style={{ padding: "5px" }} />
          <FlatButton
            primary
            label=""
            style={styles.removeButton}
            onClick={() => fields.remove(index)}
            icon={<ActionDelete />}
          />
        </TableRowColumn>
      </TableRow>
    );
  };

  renderMarketers = (children, record, resource, basePath) => {
    return (
      <div style={{ marginTop: 16 }}>
        <Card
          expanded={this.state.expandedMarketer}
          onExpandChange={this.handleExpandMarketerChange}
          style={{ marginBottom: 16 }}
        >
          <CardHeader
            title="Marketers"
            avatar={<Avatar icon={<IconPeople />} />}
            actAsExpander={true}
            showExpandableButton={true}
          />
          <CardText expandable={true} style={{ padding: 0 }}>
            <div style={{ margin: 16 }}>
              <FieldArray
                name="marketers"
                component={this.renderMarketersList}
              />
            </div>
          </CardText>
        </Card>
      </div>
    );
  };
  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar
    } = this.props;
    return (
      <div>
        <form className="simple-form">
          <Responsive
            small={
              <div style={{ padding: "3em 1em 6em 1em" }}>
                {Children.map(
                  children,
                  input =>
                    input && (
                      <div
                        key={input.props.source}
                        className={`aor-input-${input.props.source}`}
                        style={input.props.style}
                      >
                        <FormField
                          input={input}
                          resource={resource}
                          record={record}
                          basePath={basePath}
                        />
                      </div>
                    )
                )}
                {this.renderMarketers(children, record, resource, basePath)}
              </div>
            }
            medium={
              <div style={{ padding: "0 1em 1em 1em" }}>
                {Children.map(
                  children,
                  input =>
                    input && (
                      <div
                        key={input.props.source}
                        className={`aor-input-${input.props.source}`}
                        style={input.props.style}
                      >
                        <FormField
                          input={input}
                          resource={resource}
                          record={record}
                          basePath={basePath}
                        />
                      </div>
                    )
                )}
                {this.renderMarketers(children, record, resource, basePath)}
              </div>
            }
          />
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
        <Snackbar
          open={this.state.open}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}
/*
<div style={{width:400}}>
		<Values form="record-form" />
</div>
*/

const styles = {
  rowMarketers: { width: "120px", paddingLeft: 0, paddingRight: 0 },
  rowFooter: { textAlign: "right", width: 140, padding: "0 10px" },
  removeButton: { minWidth: 30 },
  selectOptions: { width: "120px" }
};

PageForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func
};

PageForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};

const selector = formValueSelector("record-form");
const enhance = compose(
  connect((state, props) => {
    const marketers = selector(state, "marketers");
    return {
      initialValues: getDefaultValues(state, props),
      marketers
    };
  }),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(PageForm);



// WEBPACK FOOTER //
// ./src/pages/PageForm.js